import {FC, useState} from "react";
import {Button, Modal, theme, Typography} from "antd";
import {QuestionCircleFilled} from "@ant-design/icons";

export const BannerRulesModal: FC = () => {
    const { token } = theme.useToken();

    const [open, setOpen] = useState(false);

    return (
        <>
            <Button size="small" type="text" icon={<QuestionCircleFilled style={{ color: token.colorTextSecondary }} />} onClick={() => setOpen(true)}>
                <Typography.Text type="secondary">Правила оформления баннера</Typography.Text>
            </Button>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                cancelText="Закрыть"
                okButtonProps={{style: {display: 'none'}}}
                title="Правила оформления баннеров"
            >
                <Typography.Paragraph>
                    <ul>
                        <li>Оформление в соответствии с официальным брендбуком дивизиона</li>
                        <li>Соотношение 16:9, рекомендуемое разрешение ― 1920х1080</li>
                        <li>Отступ от края не менее 40 пикселей для логотипов и текста</li>
                        <li>Логотипы не должны быть доминирующими и привлекать внимания больше основного изображения,
                            текста
                        </li>
                        <li>Обязательно наличие логотипа дивизиона VATRUS, других дивизионов (если применимо) и
                            субдивизионов, участвующих в проведении ивента
                        </li>
                        <li>Отсутствие изображений людей, позволяющее их идентифицировать</li>
                        <li>Отсутствие копирайтов, если лицензия запрещает использовать изображение без согласия
                            автора
                        </li>
                        <li>Соответствие руководящим документам сети (Code of Conduct VATSIM и прочее)</li>
                    </ul>
                </Typography.Paragraph>
            </Modal>
        </>
    )
}